function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.88563 5.04081L7.64792 0.224494C7.79593 0.0748312 7.98422 0 8.21301 0C8.4417 0 8.62999 0.0748312 8.778 0.224494C8.926 0.374147 9 0.56463 9 0.795922C9 1.02721 8.926 1.2177 8.778 1.36735L3.45066 6.7551C3.28922 6.9184 3.10088 7 2.88563 7C2.67039 7 2.48205 6.9184 2.32061 6.7551L0.221966 4.63271C0.0739921 4.48303 0 4.29249 0 4.06121C0 3.82993 0.0739921 3.63948 0.221966 3.48981C0.369949 3.34015 0.558294 3.26532 0.786992 3.26532C1.01569 3.26532 1.20403 3.34015 1.35201 3.48981L2.88563 5.04081Z",
  fill: "currentColor"
});

function SvgIconCheckboxTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxTick);
export default __webpack_public_path__ + "static/media/icon-checkbox-tick.6186e211efff37f75d53d500ac6d63c6.svg";
export { ForwardRef as ReactComponent };